export interface User {
    id?: number
    name: string
    isActive: number
    surname: string
    userRoleId: number
    password: string
    username: string

    key?: string
}

export enum UserRoles {
    ALL = 'ALL',
    ADMIN = 1,
    BASIC = 2,
}